import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchMapTypes } from "../redux/slice/mapSlice";
import { fetchJantriTypes } from "../redux/slice/jantriSlice";
import NavigationBar from "./NavigationBar";
import Sidebar from "./Sidebar";

export default function DashboardLayout() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    dispatch(fetchMapTypes({ is_active: true }));
    dispatch(fetchJantriTypes({ is_active: true }));
  }, [dispatch]);

  useEffect(() => {
    const idx = window.history.state?.idx;
    if (typeof idx === "number") {
      try {
        const historyStack = JSON.parse(sessionStorage.getItem("nav_history") || "[]");
        // Trim any forward history if we arrived here from a back/pop state and are pushing new paths
        const newStack = historyStack.slice(0, idx + 1);
        newStack[idx] = {
          pathname: location.pathname,
          search: location.search,
        };
        sessionStorage.setItem("nav_history", JSON.stringify(newStack));
      } catch (e) {
        console.error("Error tracking navigation history:", e);
      }
    }
  }, [location]);

  return (
    <div className={`h-100 position-relative main-content ${isCollapsed ? "sidebar-collapsed" : ""}`}>
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />

      <div className="position-relative pg-content">
          <NavigationBar />
        <div className="px-4 mx-auto pg-container">
          <main className="py-4">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
